/*
    server file, contain all the logic to communicate to the server

    common language:
    - server_***
    - server_***_cl = child listener
    - server_***_vl = value listener

    - server_***_**_removeListener
    - server_***_**_getRefStatus
 */

import {helper_finishRiddle_fb, helper_getClassAsObj, helper_randomNum_n} from "../S_Helper";

import {validator_class_fb, validator_number_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {notification_notify} from "../S_Notification";
import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
import {
    FB_File,
    FB_GameStatus,
    FB_GameStatus_Team,
    FB_GameStatus_team_player,
    FB_Message, FB_RiddleStatus,
    FB_RiddleStatus_unlockData,
    FB_RiddleStatus_userAction, FB_RS_LockData, FB_SavedMessages,
    FB_TeamPlayerInfo, FB_TeamStatus,
    FB_UserGeoLocation
} from "../../../functions/src/shareCode/Share_S_Classes";
import {
    enum_cluesMode_e,
    enum_fbPath, enum_hiddenCodesTypes,
    enum_lockState,
    enum_lockTypes,
    enum_totalPointsIdPrefix
} from "../../../functions/src/shareCode/Share_S_Enum";
import {
    fbRef_subRef,
    http_database_getNewKey_f,
    http_database_getOnce_f, http_websocket_multiUpdate_f,
    http_database_onChildListener_close_f,
    http_database_onChildListener_open_f,
    http_database_onValueListener_close_f,
    http_database_onValueListener_open_f,
    http_database_setData_f,
    http_database_transaction_f,
    http_database_updateData_f,
    http_endPointPath_oa,
    http_endPointPath_of,
    http_storage_uploadFile_f,
    http_translate_fp,
    http_translation_detect_fp,
} from "./S_HttpRequests";
import {obj_deepCopy_f, obj_map_fo} from "../../../functions/src/shareCode/Share_S_Obj";
import {date_newDate_fd, date_setTimeout} from "../S_Date";
import {server_translateText_fp} from "@/scripts/Server/S_ServerPre";
import { file_downloadJson_f } from "../S_Files";

// ============ geo location ================
// getPlayersLocationListener
export const serverOngoing_teamPlayersGeoLocation_cl_set_f = (viewName_s, questEvent_c, teamId, cb_f) => {

    // let ref = REF_REALTIME_ONGOING_PLAYERS_LOCATION.child(`${questEvent_c.qev_questId_uid}/${questEvent_c.qev_eventId_uid}/${teamId}`)
    //
    // serverStorage_getListener_list_f({
    //     endPointName        : enum_endPointsNames.getTeamPlayersGeoLocation,
    //     viewName_s          : viewName_s,
    //     ref                 : ref,
    //
    //     server_f            : realTimeDB_setOnChildListener,
    //     classType_o         : FB_UserGeoLocation,
    //     getDataUid_f        : (data) => {return data.userId_uid},
    //
    //     childAddedCb_f      : childAddedCb_f,
    //     childChangedCb_f    : childChangeCb_f})

    http_database_onChildListener_open_f({
        path_as     : http_endPointPath_oa.DATABASE_ONGOING_TEAM_PLAYER_GEO_LOCATIONS.concat(questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId),
        viewName_s  : viewName_s,
        cb_f : (userGeoLocation_o) => {
            cb_f(userGeoLocation_o != null ? new FB_UserGeoLocation(userGeoLocation_o): null)
        }
    })


}
export const serverOngoing_teamPlayersGeoLocation_cl_remove_f = (viewName_s, questEvent_c, teamId) =>{
    // let ref = REF_REALTIME_ONGOING_PLAYERS_LOCATION.child(`${questEvent_c.qev_questId_uid}/${questEvent_c.qev_eventId_uid}/${teamId}`)

    // serverStorage_removeListener_f(
    //     enum_endPointsNames.getTeamPlayersGeoLocation,
    //     viewName_s,
    //     getRefKey_fs(ref),
    //     () => {
    //         removeRefListener(ref)
    //     }
    // )

    http_database_onChildListener_close_f({
        viewName_s : viewName_s,
        path_as :http_endPointPath_oa.DATABASE_ONGOING_TEAM_PLAYER_GEO_LOCATIONS.concat(questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId)
    })

}
// server_set_teamPlayerGeoLocation
export const serverOngoing_teamPlayerGeoLocation_set = (questId_uid, eventId_uid, teamId_uid, userGeoLocation_c) => {

    // let ref = REF_REALTIME_ONGOING_PLAYERS_LOCATION.child(questId_uid).child(eventId_uid).child(teamId_uid).child(userId_uid)
    // realTimeDB_updateData(ref, teamPlayerGeoLocation_c, () => {})

    http_database_updateData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_TEAM_PLAYER_GEO_LOCATIONS.concat(questId_uid, eventId_uid, teamId_uid, userGeoLocation_c.ugl_userId_uid),
        data_c : userGeoLocation_c,
        cb_f : () => {},
    })
}


// ============ player more info  ================
// server_update_teamPlayerInfo
export const serverOngoing_teamPlayerInfo_update_f = ({teamPlayerInfo_c, questEvent_c, userId_uid}) => {

    // let ref = getRef_playerMoreInfo(questId_uid, eventId_uid, userId_uid)
    //
    // realTimeDB_updateData_transaction(
    //     ref,
    //     (teamStatus) => {
    //
    //         if(teamPlayerInfo_c.pmi_batteryLevel_n >= 0){
    //             teamStatus.pmi_batteryLevel_n = teamPlayerInfo_c.pmi_batteryLevel_n
    //         }
    //
    //         if(teamStatus.pmi_walkInMeters_n > 0){
    //             teamStatus.pmi_walkInMeters_n += parseInt(teamPlayerInfo_c.pmi_walkInMeters_n.toFixed(2));
    //         }else{
    //             teamStatus.pmi_walkInMeters_n = parseInt(teamPlayerInfo_c.pmi_walkInMeters_n.toFixed(2))
    //         }
    //     },
    //     () => {});


    http_database_transaction_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_ONGOING_PLAYER_MORE_INFO.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, userId_uid),

        updateData_fo : (teamPlayerInfo_o) =>{

            if(teamPlayerInfo_c.pmi_batteryLevel_n >= 0){
                teamPlayerInfo_o.pmi_batteryLevel_n = teamPlayerInfo_c.pmi_batteryLevel_n
            }

            if(teamPlayerInfo_o.pmi_walkInMeters_n > 0){
                teamPlayerInfo_o.pmi_walkInMeters_n += parseInt(teamPlayerInfo_c.pmi_walkInMeters_n.toFixed(2));
            }else{
                teamPlayerInfo_o.pmi_walkInMeters_n = parseInt(teamPlayerInfo_c.pmi_walkInMeters_n.toFixed(2))
            }

            return teamPlayerInfo_o
        },
        cb_f : () => {},
    })

}
// server_vl_playerMoreInfo_get
export const serverOngoing_playerMoreInfo_vl_set_f = (viewName_s, questEvent_c, userId_uid, cb_f) => {


    // serverStorage_getListener_value_f({
    //     endPointName_s  : 'server_vl_playerMoreInfo_get',
    //     viewName_s      : viewName_s,
    //     ref_o           : getRef_playerMoreInfo(questId_uid, eventId_uid, userId_uid),
    //     serverFunc_f    : realTimeDB_onValueListener,
    //     classType_o     : FB_TeamPlayerInfo,
    //     cb_f            : cb_f
    // })

    http_database_onValueListener_open_f({
        viewName_s  : viewName_s,
        path_as     : http_endPointPath_oa.DATABASE_ONGOING_ONGOING_PLAYER_MORE_INFO.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, userId_uid),
        cb_f : (teamPlayerInfo_o) => {
            cb_f(teamPlayerInfo_o != null ? new FB_TeamPlayerInfo(teamPlayerInfo_o) : null)
        }
    })



}
export const serverOngoing_playerMoreInfo_vl_remove_f = (viewName_s, questEvent_c, userId_uid, cb_f) => {

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.DATABASE_ONGOING_ONGOING_PLAYER_MORE_INFO.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, userId_uid)
    })

}


// ============ chat ================
// server_getOngoingChatMessages_cl
export const serverOngoing_chatMessages_cl_set_f = (viewName_s, currentUserId, questEvent, teamId, cb_f) => {

    http_database_onChildListener_open_f({
        viewName_s : viewName_s,
        cacheFallback_b: true,
        path_as    : http_endPointPath_oa.DATABASE_ONGOING_QUESTS_CHATS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid, teamId),
        cb_f : (message_o) => {
            cb_f(message_o != null ? new FB_Message(message_o) : null)
        }
    })

}
export const serverOngoing_chatMessages_cl_remove = (viewName_s, questEvent, teamId) => {


    http_database_onChildListener_close_f({
        viewName_s : viewName_s,
        path_as    : http_endPointPath_oa.DATABASE_ONGOING_QUESTS_CHATS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid, teamId),

    })

}
// serverOngoing_chatMessage_send_f
export const serverOngoing_chatMessage_send_f = (questEvent_c, teamId_uid, msg_c, cb_f) => {

    if (msg_c.ms_text_s === "") {
        notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_cantSendEmptyMessage)
        return;
    }

    http_database_setData_f({
        cacheFallback_b: true,
        path_as : http_endPointPath_oa.DATABASE_ONGOING_QUESTS_CHATS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, msg_c.ms_sendTime_n),
        data_c  : msg_c,
        cb_f    : cb_f
    })
    
}
// serverOngoing_chatMessage_send_f
export const serverOngoing_chatMessage_translate_f = async (questEvent_c, teamId_uid, msg_c, translateLangCode_e, cb_f) => {

    // google translate
    let translateText_s = await http_translate_fp({
        textToTranslate_s: msg_c.ms_text_s,
        targetLang_e: translateLangCode_e
    })

    http_database_updateData_f({
        path_as: http_endPointPath_oa.DATABASE_ONGOING_QUESTS_CHATS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid,
            msg_c.ms_sendTime_n, FB_Message.ms_l_translate_blc_s),
        data_c: {[translateLangCode_e]: translateText_s},
        cb_f: cb_f
    })
}
// serverOngoing_chatMessage_receive_f
export const serverOngoing_chatMessage_receive_f = (questEvent, teamId, newMsg, userId) => {

    // check if user didnt read this msg
    if(newMsg.ms_receiveMsg_byUserId_b[userId]){
        return
    }

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_QUESTS_CHATS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid, teamId, newMsg.ms_sendTime_n, enum_fbPath.ms_receiveMsg_byUserId_b, userId),
        data_c  : true,
        cb_f    : () => {}
    })
}
// serverOngoing_chatMessage_read_f
export const serverOngoing_chatMessage_read_f = (context, questEvent, teamId, newMsg , userId) => {

    // check if user didnt read this msg
    if(newMsg.ms_readMsg_byUserId_b[userId]){
        return
    }

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_QUESTS_CHATS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid, teamId, newMsg.ms_sendTime_n, enum_fbPath.ms_readMsg_byUserId_b, userId),
        data_c  : true,
        cb_f    : () => {}
    })
}
// serverOngoing_savedMsg
export const serverOngoing_savedMsg_getOnce_f = (questEvent_c, cb_f) => {

    http_database_getOnce_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_SAVED_MESSAGES.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid),
        cb_f : (savedMessages_byTimestamp_c) => {
            cb_f(savedMessages_byTimestamp_c ? obj_map_fo(savedMessages_byTimestamp_c, (savedMsg_o) => {return new FB_SavedMessages(savedMsg_o)}) : {})
        }
    })
}
export const serverOngoing_savedMsg_set_f = (questEvent_c, timestamp_t, savedMessage_c, cb_f) => {

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_SAVED_MESSAGES.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid,timestamp_t),
        data_c  : savedMessage_c,
        cb_f    : cb_f
    })
}


// ============ teams and game ================
// serverOngoing_createNewTeam_f
export const serverOngoing_createNewTeam_f = (questEvent_c, questBody_c, teamName_s, teamColor_s, teamPassword_s, selectedRouteIndex_n, userId_uid, cb_f) => {

    http_database_getNewKey_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId),
        cb_f : (newTeamId_uid) =>{
            serverOngoing_createNewTeam_withTeamId_f(questEvent_c, questBody_c, teamName_s, teamColor_s, teamPassword_s, selectedRouteIndex_n, userId_uid, newTeamId_uid, cb_f)
        }
    })

}
export const serverOngoing_createNewTeam_withTeamId_f = (questEvent_c, questBody_c, teamName_s, teamColor_s, teamPassword_s, selectedRouteIndex_n, userId_uid, newTeamId_uid, cb_f) => {

    // 1) add team to GAME_STATUS
    let now = date_newDate_fd()
    let gameStatus_team =  new FB_GameStatus_Team( {
        gst_teamId_uid: newTeamId_uid,
        gst_name_s: teamName_s,
        gst_color_s: teamColor_s,
        gst_players_byUserId_c: {},
        gst_teamPassword_s: teamPassword_s,
        gst_missionsArrangementIndex_n : selectedRouteIndex_n != null ? selectedRouteIndex_n : helper_randomNum_n(questBody_c.qb_missionsArrangements_ac.length)
    })

    if(userId_uid != null){
        gameStatus_team.gst_players_byUserId_c[userId_uid] = new FB_GameStatus_team_player({
            gstp_playerId_uid : userId_uid,
            gstp_joinedTime_t : now.getTime(),
        })
    }

    // 2) create TEAM_STATUS
    let teamStatus =  new FB_TeamStatus( {
        ts_teamId_uid: newTeamId_uid,
        ts_usedClues_as: [],
        ts_cluesLeft_n: questBody_c.qb_startingCluesNum_n,
        ts_skipsLeft_n: questBody_c.qb_startingSkipsNum_n,
    })


    console.log(newTeamId_uid, teamStatus)

    // 2) add to gameStatus
    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, newTeamId_uid),
        data_c  : gameStatus_team,
        cb_f    : () => {

            // create new teamStatus
            http_database_setData_f({
                path_as : http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, newTeamId_uid),
                data_c  : teamStatus,
                cb_f    : cb_f
            })

        }
    })

}
export const serverOngoing_setFinishTime_f = ({questEvent_c, teamId_uid}) => {

    http_database_transaction_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid),
        updateData_fo : (gs_team_o) =>{

            if(gs_team_o.gst_finishTime_t == null){
                gs_team_o.gst_finishTime_t = date_newDate_fd().getTime()
            }

            return gs_team_o
        },
        cb_f : () => {},
    })
}


// ============ gameStatus ================
export const serverOngoing_gameStatus_timeExtensions_update_f = (questEvent, timeExtensionMinutes_n, cb_f) => {

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent.qev_questType_e,  questEvent.qev_questId_uid, questEvent.qev_eventId_uid, enum_fbPath.gs_timeExtensionMinutes_n),
        data_c  : timeExtensionMinutes_n,
        cb_f    : cb_f
    })


}
export const serverOngoing_gameStatus_creatorSetStartTime_update_f = (questEvent_c, startTime_t, cb_f) => {

    // let ref = getRef_gameStatus_creatorStartTime(questEvent_c)
    //
    // realTimeDB_setData(ref, startTime_t, cb_f)

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, fbRef_subRef.gs_creatorStartTime_t),
        data_c  : startTime_t,
        cb_f    : cb_f
    })
}
export const serverOngoing_gameStatus_playerJoinTeam_f = (questEvent, teamId, userId, callback) =>{

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId,
            teamId, enum_fbPath.gst_players_byUserId_c, userId),
        data_c  : new FB_GameStatus_team_player({
            gstp_playerId_uid : userId,
            gstp_joinedTime_t : (date_newDate_fd()).getTime(),
        }),
        cb_f    : callback
    })

}
export const serverOngoing_gameStatus_team_playerSetStartTime_f = (questEvent_c, teamUid_uid, startTime_t, cb_f) => {

    http_database_setData_f({
        retryFailedMsg_b: true,
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid,
            FB_GameStatus.gs_l_teams_byTeamId, teamUid_uid, fbRef_subRef.gst_playerStartTime_t),
        data_c  : startTime_t,
        cb_f    : cb_f
    })
}
export const serverOngoing_gameStatus_team_update_f = (questEvent, teamId, gameStatusTeam, cb) => {

    console.log("serverOngoing_gameStatus_team_update_f")
    http_database_updateData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent.qev_questType_e,  questEvent.qev_questId_uid, questEvent.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId),
        data_c : gameStatusTeam,
        cb_f : cb
    })
}
export const serverOngoing_gameStatus_team_player_path_update_f = (questEvent_c, teamId_uid, playerId_uid, gst_player_c, cb) => {

    http_database_updateData_f({
        path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid,
            FB_GameStatus.gs_l_teams_byTeamId, teamId_uid, fbRef_subRef.gst_players_byUserId_c, playerId_uid),
        data_c: gst_player_c,
        cb_f: cb
    })
}
export const serverOngoing_gameStatus_team_delete_f = (questEvent, teamId, cb_f) => {

    http_database_setData_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent.qev_questType_e,  questEvent.qev_questId_uid, questEvent.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId),
        data_c  : null,
        cb_f    : cb_f
    })
}
// listener
export const serverOngoing_gameStatus_vl_set_f = (viewName_s, questType, questId, eventId, cacheFallback_b, cb_f) => {


    http_database_onValueListener_open_f({
        viewName_s  : viewName_s,
        path_as     : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questType, questId, eventId),
        cacheFallback_b, 
        cb_f : (gameStatus_o) => {
            cb_f(gameStatus_o != null ? new FB_GameStatus(gameStatus_o) : new FB_GameStatus({}))
        }
    })


}
export const serverOngoing_gameStatus_vl_remove_f = (viewName_s, questEvent) => {
    // let ref = getRef_gameStatus(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid)
    //
    // serverStorage_removeListener_f(
    //     'server_vl_gameStatus_get',
    //     viewName_s,
    //     getRefKey_fs(ref),
    //     () => {
    //         removeRefListener(ref)
    //     }
    // )

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent.qev_questType_e, questEvent.qev_questId_uid, questEvent.qev_eventId_uid)
    })


}


// ============ teamStatus ================
// serverOngoing_teamStatus_update_f
export const serverOngoing_teamStatus_update_f = ({questEvent_c, newTeamStatus_c, oldTeamStatus_c}) =>{

    let dataToSend_ao = [{
        path_as : http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, newTeamStatus_c.ts_teamId_uid),
        data_o  :  newTeamStatus_c
    }]

    // update gameStatusPoints
    if(newTeamStatus_c.ts_bonusPoints_n !== oldTeamStatus_c.ts_bonusPoints_n) {
        dataToSend_ao.push({
            path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid,
                FB_GameStatus.gs_l_teams_byTeamId, newTeamStatus_c.ts_teamId_uid, FB_GameStatus_Team.gst_l_totalPoints_byId_n, enum_totalPointsIdPrefix.bonusPoints_s),
            data_o  :  newTeamStatus_c.ts_bonusPoints_n
        })
    }

    http_websocket_multiUpdate_f({
        dataToSend_ao : dataToSend_ao,
        basePath_as : http_endPointPath_oa.DATABASE_ONGOING
    })

}

// serverOngoing_teamStatus_vl
export const serverOngoing_teamStatus_vl_set_f = ({viewName_s, questEvent_c, teamId_uid, cacheFallback_b=false, cb_f}) => {

    http_database_onValueListener_open_f({
        viewName_s,
        cacheFallback_b,
        path_as     : http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid),
        cb_f : (teamStatus_o) => {
            cb_f(teamStatus_o == null ? null  : new FB_TeamStatus(teamStatus_o))
        }
    })

}
// serverOngoing_teamStatus_vl
export const serverOngoing_teamStatus_temp_f = (questEvent_c) => {

    // const ans = {}
    // http_database_getOnce_f({
    //     path_as     : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid),
    //     cb_f : (data_c) => {
    //         console.log("dantest1", data_c)
    //         for(let teamId in data_c.gs_teams_byTeamId){
    //             const teamData_c = data_c.gs_teams_byTeamId[teamId]

    //             ans[teamId] = {
    //                 name : teamData_c.gst_name_s,
    //                 points: teamData_c.gst_totalPoints_byId_n && Object.values(teamData_c.gst_totalPoints_byId_n).reduce((total, val) => total + val, 0)
    //             }
    //         }

    //         http_database_getOnce_f({
    //             path_as : http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F("LIST_MISSIONS").concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid),
    //             cb_f : (data2_c) => {
    //                 console.log("dantest2", data2_c)

    //                  for(let teamId in data2_c){
    //                     const riddleStatus_byRiddleId_c = data2_c[teamId]

    //                     if(ans[teamId]){
    //                         const riddle5 = riddleStatus_byRiddleId_c['5']
    //                         const riddle7 = riddleStatus_byRiddleId_c['7']
    //                         const riddle8 = riddleStatus_byRiddleId_c['8']

    //                         ans[teamId]['time_ms_3_1'] = riddle5 && riddle5.rs_unlock_byLockId_c && riddle5.rs_unlock_byLockId_c[0].rsud_timestemp_t - riddle5.rs_startMissionTime_t
    //                         ans[teamId]['time_ms_3_2'] = riddle7 && riddle7.rs_unlock_byLockId_c && riddle7.rs_unlock_byLockId_c[0].rsud_timestemp_t - riddle7.rs_startMissionTime_t
                        
    //                         ans[teamId]['ans_1'] = riddle8 && riddle8.rs_unlock_byLockId_c && riddle8.rs_unlock_byLockId_c[0].rsud_quizUserAns_byQuestionIndex_as + ''
    //                     }

                        
    //                 }

    //                 console.log("dantest3", ans)
    //                 file_downloadJson_f('19/03/2023', ans)
        
    //             }
    //         })   

    //     }
    // })

}

export const serverOngoing_teamStatus_vl_remove_f = (viewName_s, questEvent_c, teamId_uid) => {
    // let ref = getRef_teamStatus(questEvent_c, teamId_uid)
    //
    // serverStorage_removeListener_f(
    //     'server_vl_teamStatus_get_f',
    //     viewName_s,
    //     getRefKey_fs(ref),
    //     () => {
    //         removeRefListener(ref)
    //     }
    // )

    http_database_onValueListener_close_f({
        viewName_s : viewName_s,
        path_as : http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid)
    })

}


// ============ teamStatusSub ================

// serverOngoing_teamStatusSub_riddleStatus_useSkip_f
export const serverOngoing_teamStatusSub_riddleStatus_useSkip_f = ({questEvent_c, teamId_uid,  teamStatus_subCollection_e, riddleId_n, unlocksData_byLockId, finishRiddle_fb, lastRiddle_fb, cb_f}) => {

    http_database_transaction_f({
        path_as : http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid),
        updateData_fo : (teamStatus_o) =>{

            if(teamStatus_o.ts_skipsLeft_n <= 0){
                return null
            }

            teamStatus_o.ts_skipsLeft_n--;

            return teamStatus_o
        },
        cb_f : () => {

            http_database_transaction_f({
                path_as : http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n),

                updateData_fo : (riddleStatus_o) =>{

                    // set riddle id
                    if(riddleStatus_o.rs_riddleId_n == null){
                        riddleStatus_o.rs_riddleId_n = riddleId_n
                    }

                    // init teamStatus
                    if(riddleStatus_o.rs_unlock_byLockId_c == null){
                        riddleStatus_o.rs_unlock_byLockId_c = {}
                    }
                    for(let lockId_n in unlocksData_byLockId){

                        riddleStatus_o.rs_unlock_byLockId_c[lockId_n] = helper_getClassAsObj(unlocksData_byLockId[lockId_n])
                    }

                    return riddleStatus_o
                },
                cb_f : (data_o) => {

                    // update finish time
                    date_setTimeout( () => {

                        if(lastRiddle_fb && lastRiddle_fb() && finishRiddle_fb && finishRiddle_fb()){
                            serverOngoing_setFinishTime_f({questEvent_c: questEvent_c, teamId_uid : teamId_uid})
                        }
                    })


                    cb_f(data_o)
                },
            })

        },
    })
}

// serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f
export const serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f = async (
    {questEvent_c, teamId_uid, teamStatus_subCollection_e, lockIndex_n, riddleData_c, riddleStatus_c,
        rs_lockData_c, questSupportPoints_b, questLastRiddle_b, cb_f= ()=>{}}) => {

    const riddleId_n = riddleData_c.qbr_riddleId_n

    // 1) riddleStatus
    if(riddleStatus_c == null ){
        riddleStatus_c = new FB_RiddleStatus({
            rs_riddleId_n: riddleId_n,
        })
    }
    if(riddleStatus_c.rs_unlock_byLockId_c == null){
        riddleStatus_c.rs_unlock_byLockId_c = {}
    }

    riddleStatus_c.rs_unlock_byLockId_c[lockIndex_n] = rs_lockData_c
    const finishLastRiddle_b = questLastRiddle_b && helper_finishRiddle_fb(riddleData_c, riddleStatus_c)

    // 2) dataToSend
    const dataToSend_ao = [
        // 2.1) riddleStatusSub rs_riddleId_n
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_riddleId_n),
            data_o: riddleId_n
        },

        // 2.2) riddleStatusSub rs_unlock_byLockId_c[lockIndex_n]
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_unlock_byLockId_c, lockIndex_n),
            data_o: rs_lockData_c
        },

        // 2.3) gameStatus gst_totalPoints_byId_n[rl_riddleId_n_lockIndex_n]
        questSupportPoints_b &&
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid,
                FB_GameStatus_Team.gst_l_totalPoints_byId_n, `${enum_totalPointsIdPrefix.riddleLock_s}_${teamStatus_subCollection_e}_${riddleId_n}_${lockIndex_n}`),
            data_o: rs_lockData_c.rsud_lockState_e === enum_lockState.approved  ? rs_lockData_c.rsud_receivedPoints_n : 0
        },

        // 2.4) gameStatus gst_netTimeMillScn_byRiddleId_n[riddleId_n]
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid,
                FB_GameStatus_Team.gst_l_netTimeMillScn_byRiddleId_n, riddleId_n),
            data_o: riddleStatus_c.rs_m_missionTotalTime_t()
        },

        // 2.5) finishTime
        finishLastRiddle_b &&
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid,
                FB_GameStatus_Team.gst_l_finishTime_t),
            data_o: date_newDate_fd().getTime()
        }
    ].filter(item => item)

    // 3) upload to storage
    http_storage_uploadFile_f({
        file_c: rs_lockData_c.rsud_imgFile_c,
        path_as: http_endPointPath_oa.STORAGE_TEAMS_STATUS.concat(questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid),
        dataToSend_ao,
        retryFailedMsg_b : true,
        cb_f : (dataToSend_ao) => {
            
            // 4) database multiUpdate
            http_websocket_multiUpdate_f({
                dataToSend_ao,
                basePath_as: http_endPointPath_oa.DATABASE_ONGOING,
                cb_f
            })
        }
    })

}

// serverOngoing_teamStatusSub_riddleStatus_unlockData_update_f
export const serverOngoing_teamStatusSub_riddleStatus_actions_update_f = async(
    {teamStatus_subCollection_e, questEvent_c, teamId_uid, lockIndex_n, riddleData_c, riddleStatus_c,
        rs_action_c, cb_f= ()=>{}}) => {

    const riddleId_n = riddleData_c.qbr_riddleId_n
    const pathPrefix_riddleStatus = http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n)
    const pathPrefix_gameStatus_team = http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid)

    const localRiddleStatus = riddleStatus_c ?
        new FB_RiddleStatus(obj_deepCopy_f(riddleStatus_c)) :
        new FB_RiddleStatus({rs_riddleId_n : riddleId_n})

    // new lockData
    localRiddleStatus.rs_lockData_byLockIndex_c[lockIndex_n] = new FB_RS_LockData({
        rsld_lockIndex_n : lockIndex_n,
        rsld_totalPoints_n : riddleData_c.qbr_locks_ac[lockIndex_n].qbrl_points_n,
        rsld_minPoints_n : riddleData_c.qbr_locks_ac[lockIndex_n].qbrl_minPoints_n,
        rsld_errorPointCost_n : riddleData_c.qbr_locks_ac[lockIndex_n].qbrl_errorPointsCost_n,
    })
    if(localRiddleStatus.rs_lockActions_byLockIndex_byTime_c[lockIndex_n] == null){
        localRiddleStatus.rs_lockActions_byLockIndex_byTime_c[lockIndex_n] = {}
    }
    localRiddleStatus.rs_lockActions_byLockIndex_byTime_c[lockIndex_n][rs_action_c.rsla_timestamp_t] = rs_action_c

    // dataToSend
    const dataToSend_ao = [
        // 2.1) rs_riddleId_n
        {
            path_as: pathPrefix_riddleStatus.concat(FB_RiddleStatus.rs_l_riddleId_n),
            data_o: riddleId_n
        },

        // 2.2) rs_lockData_byLockIndex_c[lockIndex_n][timestamp]
        (!riddleStatus_c || !riddleStatus_c.rs_lockData_byLockIndex_c[lockIndex_n]) && {
            path_as: pathPrefix_riddleStatus.concat(FB_RiddleStatus.rs_l_lockData_byLockIndex_c, lockIndex_n),
            data_o: localRiddleStatus.rs_lockData_byLockIndex_c[lockIndex_n]
        },

        // 2.3) rs_lockActions_byLockIndex_byTime_c[lockIndex_n][timestamp]
        {
            path_as: pathPrefix_riddleStatus.concat(FB_RiddleStatus.rs_l_lockActions_byLockIndex_byTime_c, lockIndex_n, rs_action_c.rsla_timestamp_t),
            data_o: rs_action_c
        },

        // 2.4) gst_totalPoints_byId_n[uniqueId]
        localRiddleStatus.rs_m_finishActionLock_b(lockIndex_n) &&
        {
            path_as: pathPrefix_gameStatus_team.concat(FB_GameStatus_Team.gst_l_totalPoints_byId_n, `${enum_totalPointsIdPrefix.riddleLock_s}_${teamStatus_subCollection_e}_${riddleId_n}_${lockIndex_n}`),
            data_o: localRiddleStatus.rs_m_actionLock_calcPoints_n(lockIndex_n)
        },

    ].filter(item => item)

    // database multiUpdate
    http_websocket_multiUpdate_f({
        dataToSend_ao: dataToSend_ao,
        basePath_as: http_endPointPath_oa.DATABASE_ONGOING,
        cb_f : cb_f
    })

}

// serverOngoing_teamStatusSub_rsud_status_update_f
export const serverOngoing_teamStatusSub_rsud_status_update_f = ({questEvent_c, teamId_uid, riddleId_n, lockId_n, qbr_locks_c, teamStatus_subCollection_e, lockStatus_e, updateFinishTime_fb, cb_f}) => {

    // 1) dataToSend
    let dataToSend_ao = [

        // 1.1) riddleStatusSub rs_riddleId_n
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_riddleId_n),
            data_o: riddleId_n
        },

        // 1.2) riddleStatusSub rs_unlock_byLockId_c[lockIndex_n].rsud_lockType_e
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_unlock_byLockId_c, lockId_n, FB_RiddleStatus_unlockData.rsud_l_lockType_e),
            data_o: qbr_locks_c.qbrl_type_e
        },

        // 1.3) riddleStatusSub rs_unlock_byLockId_c[lockIndex_n].rsud_lockState_e
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_unlock_byLockId_c, lockId_n, FB_RiddleStatus_unlockData.rsud_l_lockState_e),
            data_o: lockStatus_e
        },

        // 1.4) riddleStatusSub rs_unlock_byLockId_c[lockIndex_n].rsud_timestemp_t
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_unlock_byLockId_c, lockId_n, FB_RiddleStatus_unlockData.rsud_l_timestemp_t),
            data_o: (date_newDate_fd()).getTime()
        },

        // 1.5) gameStatus gst_totalPoints_byId_n[rl_riddleId_n_lockIndex_n]
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid,
                FB_GameStatus_Team.gst_l_totalPoints_byId_n, `${enum_totalPointsIdPrefix.riddleLock_s}_${teamStatus_subCollection_e}_${riddleId_n}_${lockId_n}`),
            data_o: lockStatus_e === enum_lockState.approved ? qbr_locks_c.qbrl_points_n : 0
        },

        // 1.6) finishTime
        updateFinishTime_fb && updateFinishTime_fb() && {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid, FB_GameStatus_Team.gst_l_finishTime_t),
            data_o: date_newDate_fd().getTime()
        }
    ].filter(item => item )

    // 2) database multiUpdate
    http_websocket_multiUpdate_f({
        dataToSend_ao: dataToSend_ao,
        basePath_as: http_endPointPath_oa.DATABASE_ONGOING,
        cb_f : cb_f
    })
}

// serverOngoing_teamStatus_riddleStatus_startMissionTime_f
export const serverOngoing_teamStatus_riddleStatus_startMissionTime_f = ({teamStatus_subCollection_e, questEvent_c, teamId_uid, riddleId_n, cb_f}) => {

    http_database_updateData_f({
        path_as : http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e,  questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n),
        data_c : {
            [fbRef_subRef.rs_startMissionTime_t]    : date_newDate_fd().getTime(),
            [fbRef_subRef.rs_riddleId_n]            : riddleId_n,
        },
        cb_f : cb_f
    })

}

// serverOngoing_teamStatus_riddleStatus_useClue_update_f
export const serverOngoing_teamStatus_riddleStatus_useClue_update_f = ({questEvent_c, teamId_uid, userId_uid, teamStatus_subCollection_e, riddleData_c, teamStatus_c, clueId_n, clueMode_e, cb_f}) => {

    let riddleId_n = riddleData_c.qbr_riddleId_n
    let pointsWorth_n = riddleData_c.qbr_clues_ac[clueId_n].qbrc_pointsWorth_n

    // 1) dataToSend
    let dataToSend_ao = [
        // 1.1) riddleStatusSub rs_riddleId_n
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_riddleId_n),
            data_o: riddleId_n
        },

        // 1.2) riddleStatusSub rs_clues_byClueId_c[clueId_n]
        {
            path_as: http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(teamStatus_subCollection_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid, riddleId_n,
                FB_RiddleStatus.rs_l_clues_byClueId_c, clueId_n),
            data_o: new FB_RiddleStatus_userAction({
                rsua_userId_uid: userId_uid,
                rsua_timestamp_t: (date_newDate_fd()).getTime(),
                rsua_pointsWorth_n: pointsWorth_n,
            })
        },

        // 1.3) gameStatus gst_totalPoints_byId_n[rl_riddleId_n_lockIndex_n]
        [enum_cluesMode_e.points, enum_cluesMode_e.points_gradual].includes(clueMode_e) &&
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, FB_GameStatus.gs_l_teams_byTeamId, teamId_uid,
                FB_GameStatus_Team.gst_l_totalPoints_byId_n, `${enum_totalPointsIdPrefix.revealClue_s}_${teamStatus_subCollection_e}_${riddleId_n}_${clueId_n}`),
            data_o: -pointsWorth_n
        },

        // 1.4) teamStatus ts_cluesLeft_n
        [enum_cluesMode_e.counter, enum_cluesMode_e.counter_gradual].includes(clueMode_e) &&
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamStatus_c.ts_teamId_uid,
                FB_TeamStatus.ts_l_cluesLeft_n),
            data_o: teamStatus_c.ts_cluesLeft_n -1
        },

    ].filter(item => item )

    // 2) database multiUpdate
    http_websocket_multiUpdate_f({
        dataToSend_ao: dataToSend_ao,
        basePath_as: http_endPointPath_oa.DATABASE_ONGOING,
        cb_f : cb_f
    })

}

// serverOngoing_teamStatus_subCollection_cl
export const serverOngoing_teamStatus_subCollection_cl_get_f = ({viewName_s, subCollectionName_e, questEvent_c, teamId_uid, cb_ChildAdded_f}) => {

    http_database_onChildListener_open_f({
        path_as : http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(subCollectionName_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid),
        viewName_s: viewName_s,
        cacheFallback_b: true,
        cb_f : (riddleStatus_o) => {
            cb_ChildAdded_f(riddleStatus_o != null ? new FB_RiddleStatus(riddleStatus_o) : null)
        }
    })


}
export const serverOngoing_teamStatus_subCollection_cl_remove_f = ({viewName_s, subCollectionName_e, questEvent_c, teamId_uid}) => {


    http_database_onChildListener_close_f({
        viewName_s  : viewName_s,
        path_as     : http_endPointPath_of.DATABASE_ONGOING_TEAM_STATUS_SUBCOLLECTION_F(subCollectionName_e).concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamId_uid)
    })

}


// ============ update_enterUserCode ================
export const serverOngoing_hiddenClue_update_f = (questEvent_c, teamStatus_c, qbm_quest_hiddenCodesMode_e, hiddenCodeIndex_n, hiddenClue_c, cb_f) => {

    // 1) dataToSend
    let dataToSend_ao = [
        // 1.1) FB_TeamStatus.ts_l_usedClues_as
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamStatus_c.ts_teamId_uid,
                FB_TeamStatus.ts_l_usedClues_as),
            data_o: teamStatus_c.ts_usedClues_as
        },

        // 1.2) FB_TeamStatus.ts_l_cluesLeft_n
        qbm_quest_hiddenCodesMode_e === enum_hiddenCodesTypes.e_clueCounter_n &&
        {
            path_as: http_endPointPath_oa.DATABASE_ONGOING_TEAMS_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid, teamStatus_c.ts_teamId_uid,
                FB_TeamStatus.ts_l_cluesLeft_n),
            data_o: teamStatus_c.ts_cluesLeft_n + 1
        },

        // 1.3) riddleStatusSub rs_unlock_byLockId_c[lockIndex_n]
        qbm_quest_hiddenCodesMode_e === enum_hiddenCodesTypes.e_points_n &&
        {
            path_as : http_endPointPath_oa.DATABASE_ONGOING_GAME_STATUS.concat(questEvent_c.qev_questType_e, questEvent_c.qev_questId_uid, questEvent_c.qev_eventId_uid,
                FB_GameStatus.gs_l_teams_byTeamId, teamStatus_c.ts_teamId_uid, FB_GameStatus_Team.gst_l_totalPoints_byId_n, enum_totalPointsIdPrefix.hiddenClue_s + "_" + hiddenCodeIndex_n),
            data_o  :  hiddenClue_c.qbcc_points_n
        },
    ].filter(item => item)


    http_websocket_multiUpdate_f({
        basePath_as     : http_endPointPath_oa.DATABASE_ONGOING,
        dataToSend_ao   : dataToSend_ao,
        cb_f            : cb_f
    })

}

